export const ALL_TABS = [
  { key: 'dashboard',        label: 'Dashboard',            section: 'Overview' },
  { key: 'clients',          label: 'Clients',              section: 'CRM' },
  { key: 'suppliers',        label: 'Suppliers',            section: 'CRM' },
  { key: 'agents',           label: 'Agents',               section: 'CRM' },
  { key: 'sale_quotations',  label: 'Quotations',           section: 'Operations' },
  { key: 'quotations',       label: 'Pro Forma Invoices',   section: 'Operations' },
  { key: 'invoices',         label: 'Invoices',             section: 'Operations' },
  { key: 'packages',         label: 'Packages',             section: 'Operations' },
  { key: 'bookings',         label: 'Bookings',             section: 'Operations' },
  { key: 'tickets',          label: 'Ticketing',            section: 'Operations' },
  { key: 'visas',            label: 'Visas',                section: 'Operations' },
  { key: 'bills',            label: 'Bills',                section: 'Cash & Bank' },
  { key: 'receipt_vouchers', label: 'Receipt Vouchers',     section: 'Cash & Bank' },
  { key: 'payment_vouchers', label: 'Payment Vouchers',     section: 'Cash & Bank' },
  { key: 'cheque_dashboard', label: 'Cheque Dashboard',     section: 'Cash & Bank' },
  { key: 'ar',               label: 'Accounts Receivable',  section: 'Finance' },
  { key: 'ap',               label: 'Accounts Payable',     section: 'Finance' },
  { key: 'journals',         label: 'Journal Entries',      section: 'Finance' },
  { key: 'accounts',         label: 'Chart of Accounts',    section: 'Finance' },
  { key: 'client_ledger',    label: 'Client Ledger',        section: 'Ledgers' },
  { key: 'supplier_ledger',  label: 'Supplier Ledger',      section: 'Ledgers' },
  { key: 'trial_balance',    label: 'Trial Balance',        section: 'Reports' },
  { key: 'profit_loss',      label: 'Profit & Loss',        section: 'Reports' },
  { key: 'balance_sheet',    label: 'Balance Sheet',        section: 'Reports' },
  { key: 'commissions_ledger', label: 'Commissions Ledger', section: 'Reports' },
  { key: 'commission_setoff', label: 'Commission Set-Off', section: 'Reports' },
  { key: 'staff_performance', label: 'Staff Performance',   section: 'Reports' },
  { key: 'agent_sales',      label: 'Agent Sales (GP & commission)', section: 'Reports' },
  { key: 'tickets_report',   label: 'Tickets Issued (GP)',  section: 'Reports' },
  { key: 'gp_margins',       label: 'GP / Margin View',     section: 'Finance' },
  { key: 'commission_table', label: 'Commission Table',     section: 'Settings' },
  { key: 'package_options',   label: 'Package Options',     section: 'Settings' },
  { key: 'users',            label: 'Users & Roles',        section: 'Settings' },
  { key: 'terms',            label: 'Terms & Conditions',   section: 'Settings' },
];

const allKeys = ALL_TABS.map(t => t.key);

// Fixed aggregate dashboard bubbles. Individual liability accounts (e.g. loans,
// credit card, float) are added dynamically from Chart of Accounts — see
// UserList.js's WidgetChecklist, which lists every active LIABILITY account as an
// additional pickable widget with key `account:<chart_of_accounts.id>`. That's the
// "build in the system so I can do it myself" part: adding a new liability account
// in Chart of Accounts automatically makes it available here, no code change needed.
export const DASHBOARD_WIDGETS = [
  { key: 'total_payable',    label: 'Payable' },
  { key: 'total_receivable', label: 'Receivable' },
];

export const ROLE_DEFAULTS = {
  sadmin: allKeys,
  admin:  allKeys,
  staff:  allKeys.filter(k => !['users', 'terms', 'commission_table', 'commission_setoff', 'trial_balance', 'profit_loss', 'balance_sheet', 'gp_margins', 'staff_performance', 'agent_sales', 'tickets_report'].includes(k)),
  agent:  ['dashboard', 'sale_quotations', 'quotations', 'invoices', 'tickets', 'visas'],
};
